export const funcs = {
    inArray: (search, array) => {
        let BreakException = {};
        try {
            array.forEach((el) => {
                if (el === search) {
                    throw BreakException;
                }
            });
        } catch (e) {
            if (e === BreakException)
                return true;
            else throw e;
        }
        return false;
    },

    giveProductTypes() {
        return [
            {
                val: 0,
                name: "Не определен"
            },
            {
                val: 1,
                name: "Товар"
            },
            {
                val: 2,
                name: "Работа"
            },
            {
                val: 3,
                name: "Услуга"
            },
        ]
    },
    getNumberFromString(string_) {
        let numb = string_.match(/\d/g);
        if (numb !== null)
            numb = numb.join("");

        return parseInt(numb);
    },

    translateRoutes(text){
        switch (text){
            case "destroy":
                return "Удаление";
            case "update":
                return "Изменения";
            case "store":
                return "Создание";
        }
        return " ";
    }

}